module.exports = __webpack_public_path__ + "img/2-twoImg.d06fbfe7.png";